import React, { useEffect, useState, useCallback } from "react";
import creationimg from "../../../../Assets/AppComponent/Group 427319994 (1).svg";
import Userim from "../../../../Assets/AppComponent/Layer_1 (2).svg";
import closepopup from "../../../../Assets/AppComponent/Group 442 (1).svg";
import ticketNumber from "../../../../Assets/AppComponent/Vector (32).svg";
import { useDispatch, useSelector } from "react-redux";
import {
  setTheInternalDepartmentRetreve_TicketViewsActions,
  setTheInternalDepartmentRetreve_TicketRemarksActions,
  setTheInternalDepartmentRetreve_TicketTImelinesActions,
  setTheInternalDepartmentRetreve_TicketFeedbackActions,
  setTheInternalDepartmentRetreve_TicketTicketChangesActions,
  settehTicketthankspopup,
  setTheInternalDepartment_TicketFeedbackPostActions,
  settheinternaldepartmentcommandpostaction,
  settheinternaldepartmentcommanddatagetaction,
} from "../../../../Redux/Slice";
import FileAttachementPopup from "./FileAttachementPopup";
import Attachment from "../../../../Assets/AppComponent/attachment copy.svg";

import Bad from "../../../../Assets/AppComponent/Vector (18).svg";
import acceptable from "../../../../Assets/AppComponent/Vector (19).svg";
import good from "../../../../Assets/AppComponent/Union (9).svg";
import excellent from "../../../../Assets/AppComponent/Union (6).svg";

import Badunactive from "../../../../Assets/AppComponent/Union (8).svg";
import acceptableun from "../../../../Assets/AppComponent/Union (7).svg";
import goodun from "../../../../Assets/AppComponent/Vector (16).svg";
import excellentun from "../../../../Assets/AppComponent/Union (10).svg";
import { toast } from "react-toastify";
import thumbsup from "../../../../Assets/AppComponent/plastic-hand-with-thumb-up 1 (1).svg";
import { useNavigate } from "react-router-dom";
import { PresentUrl } from "../../../../text/apidata";
import { store } from "../../../../Redux/Store";
import axios from "axios";

import notifyimg from "../../../../Assets/AppComponent/Group 427320010.svg";
import backimg from "../../../../Assets/AppComponent/Union (25).svg";
import PhoneCalls from "../../../../Assets/AppComponent/Group 427320000 (1).svg";
import PersonsImgs from "../../../../Assets/AppComponent/Layer_1 (2).svg";
import { Tooltip } from "react-tooltip";
import downarrow from "../../../../Assets/AppComponent/Vector (37).svg";
import galleyimg from "../../../../Assets/AppComponent/Vector (20).svg";

import PDFIMAGE from "../../../../Assets/AppComponent/Rectangle.png";
import excelimg from "../../../../Assets/AppComponent/download.png";
import gallimages from "../../../../Assets/AppComponent/Vector (20).svg";

import downloadimg from "../../../../Assets/AppComponent/Union (11).svg";

const InternalTicketingView = () => {
  const [filePopup, setFilePopup] = useState(false);
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [activeFeedback, setActiveFeedback] = useState("excellent"); // Default active state
  const [CommentPart, setcommentpart] = useState({
    status: "2",
    feedbacks: "",
    ticket_id: state.NeededdatasListed.InternalTicketIds,
    satisfaction: "excellent",
  });
  const [PresentUrls, setPresentUrls] = useState([]);
  const [presenturlInUrl, seturlandfile] = useState([]);
  const [croppedFileState, setcroppedFilestatet] = useState([]);
  const [documentnotuploads, setdosumentuploads] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [isDragging, setIsDragging] = useState(false);

  const handleDragEnter = () => setIsDragging(true);
  const handleDragLeave = () => setIsDragging(false);
  const [Closingtheticket, settheclosingTicketing] = useState(false);
  const [ticketCloseIsed, setTicketClosised] = useState(false);

  const [remarksreopendatas, setremarksreopendata] = useState({
    documents: [],
    name: "",
  });
  const [Commentpopup, setcommetpoup] = useState(false);
  const [feedbackDisabled, setfeedbackDisabled] = useState(false);
  const [ClientTicketClose, settheClientCloseTicket] = useState(false);
  const [showTooltip, setShowTooltip] = useState(0);

  const [thankcontent, settheThanksContent] = useState(
    state.NeededdatasListed.Ticketpopup_thanks
  );

  useEffect(() => {
    if (state.NeededdatasListed.InternalTicketIds != "") {
      const payload = {
        EditId: state.NeededdatasListed.InternalTicketIds,
      };
      dispatch(setTheInternalDepartmentRetreve_TicketViewsActions(payload));
    }
  }, [state.NeededdatasListed.InternalTicketIds]);

  // useEffect(() => {
  //   const payload = {
  //     ticket: state.NeededdatasListed.InternalTicketIds
  //   }
  //   dispatch(setTheInternalDepartmentRetreve_TicketRemarksActions(payload))
  // }, [])

  // useEffect(() => {
  //   const payload = {
  //     ticket: state.NeededdatasListed.InternalTicketIds
  //   }
  //   dispatch(setTheInternalDepartmentRetreve_TicketFeedbackActions(payload))
  // }, [])

  useEffect(() => {
    const payload = {
      ticket_id: state.NeededdatasListed.InternalTicketIds,
    };
    dispatch(setTheInternalDepartmentRetreve_TicketTImelinesActions(payload));
  }, []);

  const [excalationdata, setexcalationdata] = useState({
    l1_remarks: "",
    l1_reason: "",
  });

  console.log(
    state.internalTicketFeedBack.InternalDepartments_TicketsFeedback,
    "ioasuodi InternalDepartments_Ticketsretrievedatas",

    state.internalTicketFeedBack.InternalDepartments_TicketsFeedback
      .satisfaction,
    state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark,
    state.internalTicketFeedBack.InternalDepartments_TicketsFeedback
  );

  const feedbackOptions = [
    {
      id: "bad",
      label: "Bad",
      imgSrc: activeFeedback == "bad" ? Bad : Badunactive,
      backimg: Bad,
    },
    {
      id: "acceptable",
      label: "Acceptable",
      imgSrc: activeFeedback == "acceptable" ? acceptable : acceptableun,
      backimg: acceptable,
    },
    {
      id: "good",
      label: "Good",
      imgSrc: activeFeedback == "good" ? good : goodun,
      backimg: good,
    },
    {
      id: "excellent",
      label: "Excellent",
      imgSrc: activeFeedback == "excellent" ? excellent : excellentun,
      backimg: excellent,
    },
  ];

  const handleFeedbackClick = (id) => {
    setActiveFeedback(id);
    setcommentpart({
      ...CommentPart,
      satisfaction: id,
    });
  };

  useEffect(() => {
    if (
      state.internalTicketFeedBack.InternalDepartments_TicketsFeedback !=
        null &&
      state.internalTicketFeedBack.InternalDepartments_TicketsFeedback.length >
        0
    ) {
      setfeedbackDisabled(true);
      setActiveFeedback(
        state.internalTicketFeedBack.InternalDepartments_TicketsFeedback[0]
          ?.feedbacks
      );
      setcommentpart({
        ...CommentPart,
        feedbacks:
          state.internalTicketFeedBack.InternalDepartments_TicketsFeedback[0]
            ?.feedbacks,
        satisfaction:
          state.internalTicketFeedBack.InternalDepartments_TicketsFeedback[0]
            ?.satisfaction,
        status:
          state.internalTicketFeedBack.InternalDepartments_TicketsFeedback[0]
            ?.status,
      });
      setActiveFeedback(
        state.internalTicketFeedBack.InternalDepartments_TicketsFeedback[0]
          ?.satisfaction
      );
    } else {
      setcommentpart({
        ...CommentPart,
        feedbacks: "",
        satisfaction: "excellent",
      });
      setfeedbackDisabled(false);

      setActiveFeedback("excellent");
    }
  }, [state.internalTicketFeedBack.InternalDepartments_TicketsFeedback]);
  const HandleFeedbackpopup = (parm) => {
    // setcommetpoup(true);
    setcommentpart({
      ...CommentPart,
      status: 4,
    });
  };
  const HandleTheTicketChanges = (e) => {
    const feedbacked = {
      data: CommentPart,
    };
    dispatch(
      setTheInternalDepartment_TicketFeedbackPostActions(
        feedbacked,
        settheclosingTicketing(false)
      )
    );
  };
  const HandlethRemarksfromclient = (e) => {
    /// comments,

    const fetchUploadFiles = async () => {
      await Promise.all(
        PresentUrls.map(async (item, index) => {
          try {
            if (item != undefined && item != null) {
              const response = await fetch(item.url, {
                method: "PUT",
                headers: {
                  "Content-Type": item.type,
                  "x-amz-acl": "public-read",
                },
                body: item.putfiles,
              });

              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }

              if (PresentUrls.length == index + 1) {
                const payload = {
                  data: {
                    name: remarksreopendatas.name,
                    documents: presenturlInUrl,
                  },
                  reopen: 1,
                };

                dispatch(
                  settheinternaldepartmentcommandpostaction(
                    payload,
                    setcommetpoup(false)
                  )
                );
              }
            }
          } catch (error) {
            console.error("Error uploading files:", error);
          }
        })
      );
    };

    if (remarksreopendatas.name != "") {
      if (documentnotuploads == true) {
        fetchUploadFiles();
      } else {
        const payload = {
          data: {
            name: remarksreopendatas.name,
            documents: [],
          },
          reopen: 1,
        };

        dispatch(
          settheinternaldepartmentcommandpostaction(
            payload,
            setcommetpoup(false)
          )
        );
      }
    } else {
      toast.info("Please Fill the Mandatory Fields");
    }
  };

  // console.log(remarksreopendatas, "sudaispdo remarksreopendatas");

  const handleDrop = useCallback((event) => {
    event.preventDefault();

    const droppedFiles = Array.from(event.dataTransfer.files);
    const validFiles = droppedFiles.filter((file) => {
      const isPhotoOrVideo =
        file.type.startsWith("image/") || file.type.startsWith("video/");
      const isExcel =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      const isPdf = file.type === "application/pdf";
      const isEmail = file.type === "message/rfc822"; // MIME type for email files
      const isUnder5MB = file.size <= 25 * 1024 * 1024; // 5 MB size limit
      if (!isUnder5MB) {
        toast.error(`${file.name} exceeds the 25 MB size limit.`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }

      // return (isPhotoOrVideo || isExcel || isPdf || isEmail) && isUnder5MB;
      return isUnder5MB;
    });

    const invalidFiles = droppedFiles.filter((file) => {
      const isPhotoOrVideo =
        file.type.startsWith("image/") || file.type.startsWith("video/");
      const isExcel =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      const isPdf = file.type === "application/pdf";
      const isEmail = file.type === "message/rfc822";
      const isUnder5MB = file.size <= 25 * 1024 * 1024;

      // Check if the file fails size validation
      if (!isUnder5MB) {
        toast.error(`${file.name} exceeds the 25 MB size limit.`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }

      // Check if the file fails type validation
      // if (!(isPhotoOrVideo || isExcel || isPdf || isEmail)) {
      //   toast.error(`${file.name} is not a valid file type.`, {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //   });
      // }

      // return !(isPhotoOrVideo || isExcel || isPdf || isEmail) || !isUnder5MB;
      return !isUnder5MB;
    });
    // Exit if no valid files
    if (validFiles.length === 0) {
      return;
    }

    validFiles.forEach((file) => {
      const reader = new FileReader();

      reader.onload = () => {
        const base64Url = reader.result;

        setUploadedFiles((prevFiles) => [...prevFiles, base64Url]);
      };

      reader.readAsDataURL(file);
    });

    if (validFiles.length > 0) {
      const newFiles = validFiles.map((file) => URL.createObjectURL(file));

      setUploadedFiles((prev) => [...prev, ...newFiles]);
      setdosumentuploads(true);
      setcroppedFilestatet((prev) => [...prev, ...validFiles]);

      const generateRandomNumber = () => {
        return Math.floor(Math.random() * 100000);
      };

      const createPresentData = (file) => {
        const randomNumber = generateRandomNumber();
        const formattedFilename = `ticketing_system/internal_ticket/${file.name}`; // Adjust the filename as needed
        return {
          multiple_files: [
            {
              filename: formattedFilename,
              file_type: file.type,
            },
          ],
        };
      };

      validFiles.forEach((fileOfsend) => {
        const presentData = createPresentData(fileOfsend);

        axios({
          url: PresentUrl,
          method: "post",
          data: presentData,
          headers: {
            Authorization:
              "Bearer " + store.getState().users.UserData.session.token,
          },
        })
          .then((response) => {
            // console.log('Files uploaded successfully:', response.data);
            const uploadedFiles = response.data.data;

            const newUrls = uploadedFiles.map((file) => ({
              url: file,
              type: fileOfsend.type,
              putfiles: fileOfsend,
            }));
            setPresentUrls((prevUrls) => [...prevUrls, ...newUrls]);

            const SendUrl = String(response.data.data).split("?")[0]; // Extract URL up to '?'

            if (SendUrl) {
              seturlandfile((prevUrls) => [...prevUrls, SendUrl]); // Add the URL to the array
            }
          })
          .catch((error) => {
            console.error("Error uploading files:", error);
          });
      });
    }
  }, []);
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);

    const validFiles = files.filter((file) => {
      const isPhotoOrVideo =
        file.type.startsWith("image/") || file.type.startsWith("video/");
      const isExcel =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      const isPdf = file.type === "application/pdf";
      const isEmail = file.type === "message/rfc822"; // MIME type for email files
      const isUnder5MB = file.size <= 25 * 1024 * 1024; // 5 MB size limit
      if (!isUnder5MB) {
        toast.error(`${file.name} exceeds the 25 MB size limit.`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }

      // return (isPhotoOrVideo || isExcel || isPdf || isEmail) && isUnder5MB;
      return isUnder5MB;
    });

    const invalidFiles = files.filter((file) => {
      const isPhotoOrVideo =
        file.type.startsWith("image/") || file.type.startsWith("video/");
      const isExcel =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      const isPdf = file.type === "application/pdf";
      const isEmail = file.type === "message/rfc822";
      const isUnder5MB = file.size <= 25 * 1024 * 1024;

      // Check if the file fails size validation
      if (!isUnder5MB) {
        toast.error(`${file.name} exceeds the 25 MB size limit.`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }

      // Check if the file fails type validation
      // if (!(isPhotoOrVideo || isExcel || isPdf || isEmail)) {
      //   toast.error(`${file.name} is not a valid file type.`, {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //   });
      // }

      // return !(isPhotoOrVideo || isExcel || isPdf || isEmail) || !isUnder5MB;
      return !isUnder5MB;
    });
    // Exit if no valid files
    if (validFiles.length === 0) {
      return;
    }

    const newFiles = validFiles.map((file) => URL.createObjectURL(file));
    setUploadedFiles((prev) => [...prev, ...newFiles]);
    setdosumentuploads(true);
    setcroppedFilestatet((prev) => [...prev, ...validFiles]);

    const generateRandomNumber = () => {
      return Math.floor(Math.random() * 100000);
    };
    const createPresentData = (file) => {
      const randomNumber = generateRandomNumber();
      const formattedFilename = `ticketing_system/internal_ticket/${file.name}`; // Adjust the filename as needed
      return {
        multiple_files: [
          {
            filename: formattedFilename,
            file_type: file.type,
          },
        ],
      };
    };

    validFiles.forEach((fileOfsend) => {
      const presentData = createPresentData(fileOfsend);

      axios({
        url: PresentUrl,
        method: "post",
        data: presentData,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      })
        .then((response) => {
          // console.log('Files uploaded successfully:', response.data);
          const uploadedFiles = response.data.data;

          const newUrls = uploadedFiles.map((file) => ({
            url: file,
            type: fileOfsend.type,
            putfiles: fileOfsend,
          }));
          setPresentUrls((prevUrls) => [...prevUrls, ...newUrls]);

          const SendUrl = String(response.data.data).split("?")[0]; // Extract URL up to '?'

          if (SendUrl) {
            seturlandfile((prevUrls) => [...prevUrls, SendUrl]); // Add the URL to the array
          }
        })
        .catch((error) => {
          console.error("Error uploading files:", error);
        });
    });
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const removeFile = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
    setcroppedFilestatet((prev) => prev.filter((_, i) => i !== index));
    setPresentUrls((prev) => prev.filter((_, i) => i !== index));
    seturlandfile((prev) => prev.filter((_, i) => i !== index));
  };

  const capitalizeEachWord = (str) => {
    return str && typeof str === "string"
      ? str
          .split(" ") // Split the string into an array of words
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          ) // Capitalize each word
          .join(" ") // Join the words back into a string
      : ""; // Return an empty string if the input is invalid
  };
  const formatDate = (dateString) => {
    const dateObject = new Date(dateString);

    const day = String(dateObject.getDate()).padStart(2, "0");
    const month = String(dateObject.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = dateObject.getFullYear();

    return `${day} / ${month} / ${year}`;
  };
  const formatDatefeed = (dateString) => {
    const dateObject = new Date(dateString);

    const day = String(dateObject.getDate()).padStart(2, "0");
    const month = String(dateObject.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = dateObject.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const overdueFunctions = (ticketretrieve) => {
    const convertToMinutes = (days, hours, minutes) =>
      days * 24 * 60 + hours * 60 + minutes;
    let differenceInMinutes;

    function calculateTimeStatus(differenceInMinutes) {
      console.log(
        differenceInMinutes,
        "differenceInMinutes",
        differenceInMinutes * -1
      );

      if (differenceInMinutes > 0 || differenceInMinutes == 0) {
        return "Overdue";
      }

      if (differenceInMinutes * -1 >= 1440) {
        // More than or equal to 1 day
        const days = Math.floor(differenceInMinutes * -1) / (60 * 24);
        return `${days} Days left`;
      }

      if (differenceInMinutes * -1 >= 60) {
        // More than or equal to 1 hour
        const hours = Math.floor((differenceInMinutes * -1) / 60);
        return `${hours} Hours left`;
      }

      // Less than 1 hour
      const minutes = differenceInMinutes * -1;
      return `Minutes left 
        ${minutes}`;
    }
    var remainingTimevalues;

    const formatTime = (ms) => {
      const days = Math.floor(ms / (1000 * 60 * 60 * 24));
      const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
      return { days, hours, minutes };
    };

    const formatTimeLevel = (ms, Levelonbetypes) => {
      return {
        days: Levelonbetypes === "2" ? ms : 0,
        hours: Levelonbetypes === "1" ? ms : 0,
        minutes: Levelonbetypes === "0" ? ms : 0,
      };
    };

    if (
      ticketretrieve?.created_at &&
      ticketretrieve?.department_users?.l1_user_TAT
    ) {
      const createdDate = new Date(ticketretrieve.created_at);
      const currentDate = new Date();
      const differenceInMs = currentDate - createdDate;

      const timeDifference = formatTime(differenceInMs);

      const LevelonbeTAT = Number(ticketretrieve.department_users.l1_user_TAT);
      const Levelonbetypes = ticketretrieve.department_users.l1_time_type;

      const period1Minutes = convertToMinutes(
        timeDifference.days,
        timeDifference.hours,
        timeDifference.minutes
      );

      const period2Minutes = convertToMinutes(
        Levelonbetypes === "2" ? LevelonbeTAT : 0,
        Levelonbetypes === "1" ? LevelonbeTAT : 0,
        Levelonbetypes === "0" ? LevelonbeTAT : 0
      );

      differenceInMinutes = period1Minutes - period2Minutes;
      remainingTimevalues = calculateTimeStatus(differenceInMinutes);

      return remainingTimevalues;
    }

    return remainingTimevalues;
  };
  function extractTimeFromDate(
    dateString,
    options = { hour: "2-digit", minute: "2-digit", second: "2-digit" }
  ) {
    return new Date(dateString).toLocaleTimeString("en-US", options);
  }

  const downloadAll = (remarkdocuments) => {
    const allLinks = remarkdocuments;

    if (!allLinks || allLinks.length === 0) {
      alert("No documents available for download.");
      return;
    }

    allLinks.forEach((link, index) => {
      setTimeout(() => {
        window.open(link, "_blank");
      }, index * 500); // Opens a new window every 500ms (adjust as needed)
    });
  };
  const HandletheClientTicketClose = (e) => {
    const fetchUploadFiles = async () => {
      await Promise.all(
        PresentUrls.map(async (item, index) => {
          try {
            if (item != undefined && item != null) {
              const response = await fetch(item.url, {
                method: "PUT",
                headers: {
                  "Content-Type": item.type,
                  "x-amz-acl": "public-read",
                },
                body: item.putfiles,
              });

              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }

              if (PresentUrls.length == index + 1) {
                const payload = {
                  data: {
                    l1_remarks: excalationdata.l1_remarks,
                    l1_reason: excalationdata.l1_reason,
                    l1_documents: presenturlInUrl,
                    status: "3",
                  },
                  EditId: state.NeededdatasListed.InternalTicketIds,
                };

                dispatch(
                  setTheInternalDepartmentRetreve_TicketTicketChangesActions(
                    payload,
                    settheClientCloseTicket(false)
                  )
                );
              }
            }
          } catch (error) {
            console.error("Error uploading files:", error);
          }
        })
      );
    };

    if (excalationdata.l1_remarks != "" || excalationdata.l1_reason != "") {
      if (documentnotuploads == true) {
        fetchUploadFiles();
      } else {
        const payload = {
          data: {
            l1_remarks: excalationdata.l1_remarks,
            l1_reason: excalationdata.l1_reason,
            l1_documents: [],
            status: "3",
          },
          EditId: state.NeededdatasListed.InternalTicketIds,
        };

        dispatch(
          setTheInternalDepartmentRetreve_TicketTicketChangesActions(
            payload,
            settheClientCloseTicket(false)
          )
        );
      }
    } else {
      toast.info("Please Fill the Mandatory Fields");
    }
  };

  const HandleTheTicketofCloseChanges = () => {
    const payloadupdateds = {
      data: {
        status: "3",
      },
      EditId: state.NeededdatasListed.InternalTicketIds,
    };
    console.log(payloadupdateds, "payloadupdateds");

    dispatch(
      setTheInternalDepartmentRetreve_TicketTicketChangesActions(
        payloadupdateds,
        setTicketClosised(false)
      )
    );
  };

  useEffect(() => {
    // dispatch(settheinternaldepartmentcommanddatagetaction())
    if (state.NeededdatasListed.InternalTicketIds != "") {
      const payload = {
        ticket: state.NeededdatasListed.InternalTicketIds,
      };
      dispatch(settheinternaldepartmentcommanddatagetaction(payload));
    }
  }, [state.NeededdatasListed.InternalTicketIds]);

  return (
    <>
      <div className="PopupCreations">
        <div className="InnerPopup">
          <div className="PopupContent PopupContentviews">
            <div className="row PopupRows">
              <div className="col-5 PopupRowsinnerleft PopupRowsinnerleftviews">
                <div className="Popupcreatetickets">
                  <h3>
                    {state.internalTicketView
                      .InternalDepartments_Ticketsretrievedatas.status == 0
                      ? "Opened Tickets"
                      : state.internalTicketView
                          .InternalDepartments_Ticketsretrievedatas.status == 1
                      ? "In Progress"
                      : state.internalTicketView
                          .InternalDepartments_Ticketsretrievedatas.status == 3
                      ? "Ticket Details"
                      : state.internalTicketView
                          .InternalDepartments_Ticketsretrievedatas.status ==
                          4 && "Ticket Details"}
                  </h3>

                  <div className="InnerImages">
                    <img src={creationimg} alt="" />
                  </div>
                </div>

                {state.internalTicketView
                  .InternalDepartments_Ticketsretrievedatas?.created_user
                  ?.first_name != undefined ? (
                  <div className="CreatedBy">
                    <div className="CreateBodyofcontent">
                      <div className="createrimgs">
                        <img src={Userim} alt="" />
                      </div>
                      <div>
                        <p>
                          Created by{" "}
                          {capitalizeEachWord(
                            state.internalTicketView.InternalDepartments_Ticketsretrievedatas.created_user?.first_name.toLowerCase()
                          )}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>

              <div className=" col-7 RightSideparts RightSidepartsViews">
                <div className="col-12 ClosePopupDesigns ClosePopupDesignsviews">
                  <div
                    onClick={() => {
                      if (state.NeededdatasListed.RoutesDefinedof == 0) {
                        Navigate("/internaldashboard");
                      } else {
                        Navigate("/internalTicket");
                      }
                    }}
                    className="CloseIcons"
                  >
                    <img src={closepopup} alt="" />
                  </div>
                </div>

                <div className="BeforeInnerdTicketviews">
                  <div className="row InnerFormsDetails InnerFormsDetailsviews InnerFormsDetailsviewsinternal">
                    <div className="card   Inner_ticketID_deatils  shadow-sm p-3 mb-3">
                      <div className="row align-items-center TicketDetailsRecorded">
                        <div className="col-md-1 text-center TicketNumberIcons">
                          <div className="icon-container    p-3">
                            <img src={ticketNumber} />
                          </div>
                        </div>
                        <div className="col-md-10 Ticketingrecords">
                          <p className="mb-1 heaerspara">
                            <p className="ticketheader Headerticket">
                              Ticket Number
                            </p>{" "}
                            {
                              state.internalTicketView
                                .InternalDepartments_Ticketsretrievedatas
                                .ticket_number
                            }{" "}
                            <br />
                          </p>

                          <p className="mb-1 heaerspara Dateheader ">
                            <p className="ticketheader Headerticket">
                              Created Date
                            </p>{" "}
                            {state.internalTicketView
                              .InternalDepartments_Ticketsretrievedatas
                              ?.created_at
                              ? formatDate(
                                  state.internalTicketView
                                    .InternalDepartments_Ticketsretrievedatas
                                    ?.created_at
                                )
                              : "--"}{" "}
                            <br />
                          </p>
                          <p className="mb-1 heaerspara">
                            <p className="ticketheader Headerticket">
                              Resolved Date
                            </p>{" "}
                            {state.internalTicketView
                              .InternalDepartments_Ticketsretrievedatas
                              ?.client_closing_at
                              ? formatDate(
                                  state.internalTicketView
                                    .InternalDepartments_Ticketsretrievedatas
                                    ?.client_closing_at
                                )
                              : "--"}
                          </p>
                          <div className="d-flex justify-content-between">
                            <span>
                              <p className="ticketheader Headerticket">
                                Status
                              </p>{" "}
                              <span
                                className=""
                                style={{
                                  // background: state.internalTicketView.InternalDepartments_Ticketsretrievedatas?.status == 0 ? "#FDEDE9" : // Open - light background
                                  // state.internalTicketView.InternalDepartments_Ticketsretrievedatas?.status == 1 ? "#FFF8E5" : // In Progress - yellow background
                                  // state.internalTicketView.InternalDepartments_Ticketsretrievedatas?.status == 2 ? "#E7F8ED" : // Completed - light green background
                                  // state.internalTicketView.InternalDepartments_Ticketsretrievedatas?.status == 3 ? "#DFFFE3" : // Close - light green background for Close
                                  //         "#FFDDDD", // Default for Reopen - light red background
                                  color:
                                    state.internalTicketView
                                      .InternalDepartments_Ticketsretrievedatas
                                      ?.status == 0
                                      ? "#ed4c28" // Open - red text
                                      : state.internalTicketView
                                          .InternalDepartments_Ticketsretrievedatas
                                          ?.status == 1
                                      ? "#FFB800" // In Progress - yellow text
                                      : state.internalTicketView
                                          .InternalDepartments_Ticketsretrievedatas
                                          ?.status == 2
                                      ? "#12B749" // Completed - green text
                                      : state.internalTicketView
                                          .InternalDepartments_Ticketsretrievedatas
                                          ?.status == 3
                                      ? "#8BC34A" // Close - light green text for Close
                                      : state.internalTicketView
                                          .InternalDepartments_Ticketsretrievedatas
                                          ?.status == 4
                                      ? "#ed4c28"
                                      : state.internalTicketView
                                          .InternalDepartments_Ticketsretrievedatas
                                          ?.status == 5 && "#ed4c28", // Default for Reopen - red text
                                }}
                              >
                                {state.internalTicketView
                                  .InternalDepartments_Ticketsretrievedatas
                                  .status == 0
                                  ? "Open"
                                  : state.internalTicketView
                                      .InternalDepartments_Ticketsretrievedatas
                                      .status == 1
                                  ? "In Progress"
                                  : state.internalTicketView
                                      .InternalDepartments_Ticketsretrievedatas
                                      .status == 2
                                  ? "Review"
                                  : state.internalTicketView
                                      .InternalDepartments_Ticketsretrievedatas
                                      .status == 3
                                  ? "Resolved"
                                  : state.internalTicketView
                                      .InternalDepartments_Ticketsretrievedatas
                                      .status == 4
                                  ? "Reopened"
                                  : state.internalTicketView
                                      .InternalDepartments_Ticketsretrievedatas
                                      .status == 5 && "Reject"}
                              </span>
                            </span>
                          </div>

                          <div className="d-flex justify-content-between">
                            <span>
                              <p className="ticketheader Headerticket">
                                Priority
                              </p>
                              <span
                                style={{
                                  color:
                                    state.internalTicketView
                                      .InternalDepartments_Ticketsretrievedatas
                                      .priority == 0
                                      ? "green"
                                      : state.internalTicketView
                                          .InternalDepartments_Ticketsretrievedatas
                                          .priority == 1
                                      ? "#e4e42e"
                                      : state.internalTicketView
                                          .InternalDepartments_Ticketsretrievedatas
                                          .priority == 2 && "red",
                                }}
                              >
                                {state.internalTicketView
                                  .InternalDepartments_Ticketsretrievedatas
                                  .priority == 0
                                  ? "Low"
                                  : state.internalTicketView
                                      .InternalDepartments_Ticketsretrievedatas
                                      .priority == 1
                                  ? "Medium"
                                  : state.internalTicketView
                                      .InternalDepartments_Ticketsretrievedatas
                                      .priority == 2 && "High"}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="Innerscrollabledesigns">
                      <div className="InnerRecentTicketIndetails">
                        <div class="accordion" id="accordionExample">
                          <div class="card  ">
                            <div
                              class="card-header HeaderCardsticketdetails"
                              id="headingOne"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              <h5 class="mb-0">
                                <button
                                  class="btn btn-link d-flex justify-content-between align-items-center"
                                  type="button"
                                >
                                  Ticket Details
                                  <span class="icon">
                                    <img
                                      src={downarrow}
                                      className="rotate-icon"
                                    />
                                  </span>
                                </button>
                              </h5>
                            </div>

                            <div
                              id="collapseOne"
                              // class="collapse show"
                              className={`collapse ${
                                state.internalTicketView
                                  .InternalDepartments_Ticketsretrievedatas
                                  ?.status == 2
                                  ? "hide_ticket"
                                  : "show"
                              }`}
                              aria-labelledby="headingOne"
                              data-bs-parent="#accordionExample"
                            >
                              <div class="card-body">
                                <div className="card shadow-sm p-3 ">
                                  <p className=" cardpara heaerspara">
                                    <span className="ticketheader ticketheadercards">
                                      Department
                                    </span>
                                    <span className="TicketDetailsContent">
                                      {state.internalTicketView
                                        .InternalDepartments_Ticketsretrievedatas
                                        ?.department_id?.department_name !=
                                      undefined?.state.internalTicketView
                                        .InternalDepartments_Ticketsretrievedatas
                                        .department_id?.department_name
                                        ? state.internalTicketView
                                            .InternalDepartments_Ticketsretrievedatas
                                            ?.department_id?.department_name
                                        : "--"}
                                    </span>
                                  </p>
                                  <p className=" cardpara heaerspara">
                                    <span className="ticketheader ticketheadercards">
                                      Category
                                    </span>
                                    <span className="TicketDetailsContent">
                                      {state.internalTicketView
                                        .InternalDepartments_Ticketsretrievedatas
                                        ?.internal_category_id
                                        ?.issue_category_id?.name != undefined
                                        ? state.internalTicketView
                                            .InternalDepartments_Ticketsretrievedatas
                                            ?.internal_category_id
                                            ?.issue_category_id?.name
                                        : "---"}
                                    </span>
                                  </p>

                                  <p className=" cardpara heaerspara">
                                    <span className="ticketheader ticketheadercards">
                                      Subcategory
                                    </span>
                                    <span className="TicketDetailsContent">
                                      {state.internalTicketView
                                        .InternalDepartments_Ticketsretrievedatas
                                        ?.internal_category_id?.name !=
                                      undefined
                                        ? state.internalTicketView
                                            .InternalDepartments_Ticketsretrievedatas
                                            ?.internal_category_id?.name
                                        : "---"}
                                    </span>
                                  </p>
                                  <p className=" cardpara">
                                    <span className="ticketheader ticketheadercards">
                                      Description
                                    </span>
                                    <span className="TicketDetailsContent">
                                      {state.internalTicketView
                                        .InternalDepartments_Ticketsretrievedatas
                                        ?.remarks || "No description available"}
                                    </span>
                                  </p>

                                  {state.internalTicketView
                                    .InternalDepartments_Ticketsretrievedatas
                                    ?.documents?.length > 0 ? (
                                    <p className=" cardpara">
                                      <>
                                        <span className="ticketheader ticketheadercards ">
                                          Attachment
                                        </span>
                                        <p className="FileAttachmentsViews">
                                          <span
                                            className="Attachmentslist"
                                            onClick={() => {
                                              setFilePopup(true);
                                            }}
                                            style={{ cursor: "pointer" }}
                                          >
                                            <img src={Attachment} />{" "}
                                            {
                                              state.internalTicketView
                                                .InternalDepartments_Ticketsretrievedatas
                                                ?.documents?.length
                                            }{" "}
                                            File(s) Attached
                                          </span>
                                          {filePopup && (
                                            <FileAttachementPopup
                                              setFilePopup={setFilePopup}
                                              filePopup={filePopup}
                                              Attchment={
                                                state.internalTicketView
                                                  .InternalDepartments_Ticketsretrievedatas
                                                  ?.documents
                                              }
                                            />
                                          )}
                                        </p>
                                        {}
                                      </>
                                    </p>
                                  ) : null}

                                  {state.internalTicketView
                                    .InternalDepartments_Ticketsretrievedatas
                                    ?.status == 3 ||
                                  (state.internalTicketView
                                    .InternalDepartments_Ticketsretrievedatas
                                    ?.status == 4 &&
                                    state.internalTicketView
                                      .InternalDepartments_Ticketsretrievedatas
                                      ?.l1_users != null &&
                                    state.internalTicketView
                                      .InternalDepartments_Ticketsretrievedatas
                                      ?.l1_users != undefined &&
                                    state.internalTicketView
                                      .InternalDepartments_Ticketsretrievedatas
                                      ?.l1_users.length > 0) ? (
                                    <p className=" cardpara">
                                      <span className="ticketheader ticketheadercards ">
                                        Assignee
                                      </span>
                                      <>
                                        {state.internalTicketView
                                          .InternalDepartments_Ticketsretrievedatas
                                          ?.l1_users != undefined &&
                                          state.internalTicketView
                                            .InternalDepartments_Ticketsretrievedatas
                                            ?.l1_users != null && (
                                                <>
                                                  {capitalizeEachWord(
                                                    state.internalTicketView.InternalDepartments_Ticketsretrievedatas?.l1_users[0].first_name.toLowerCase() +
                                                      " "
                                                  )}
                                                  {capitalizeEachWord(
                                                    state.internalTicketView.InternalDepartments_Ticketsretrievedatas?.l1_users[0].last_name.toLowerCase()
                                                  )}
                                                </>
                                          )}
                                      </>
                                    </p>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {state.internalTicketView
                          .InternalDepartments_Ticketsretrievedatas?.status !=
                          4 &&
                        state.internalTicketView
                          .InternalDepartments_Ticketsretrievedatas?.status !=
                          3 &&
                        state.internalTicketTimeline
                          .InternalDepartments_TicketsretrieveTimeline !=
                          undefined &&
                        state.internalTicketView
                          .InternalDepartments_Ticketsretrievedatas?.l1_users !=
                          null &&
                        state.internalTicketView
                          .InternalDepartments_Ticketsretrievedatas?.l1_users !=
                          undefined &&
                        state.internalTicketView
                          .InternalDepartments_Ticketsretrievedatas?.l1_users
                          .length > 0 ? (
                          <div
                            className="issueAssigner"
                            style={{ marginTop: "7px" }}
                          >
                            <div className="Issues">
                              <p>Assignee</p>
                            </div>
                            <div className="card shadow-sm p-2 phonecallcard">
                              {state.internalTicketView
                                .InternalDepartments_Ticketsretrievedatas
                                ?.l1_users != undefined &&
                                state.internalTicketView
                                  .InternalDepartments_Ticketsretrievedatas
                                  ?.l1_users != null &&
                            ( 
                                      <div
                                        className="LeveluserCards"
                                        key={
                                          state.internalTicketView
                                            .InternalDepartments_Ticketsretrievedatas
                                            .l1_users[0]
                                        }
                                      >
                                        <div className="InnercardOflevels">
                                          <div className="LevelUserImg">
                                            <img src={PersonsImgs} />
                                          </div>

                                          <div className="Contactednames">
                                            <span>
                                              {capitalizeEachWord(
                                                state.internalTicketView.InternalDepartments_Ticketsretrievedatas?.l1_users[0].first_name.toLowerCase() +
                                                  " "
                                              )}
                                              {capitalizeEachWord(
                                                state.internalTicketView.InternalDepartments_Ticketsretrievedatas?.l1_users[0].last_name.toLowerCase()
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div
                                          onMouseEnter={() => setShowTooltip(1)}
                                          onMouseLeave={() =>
                                            setShowTooltip(null)
                                          }
                                        >
                                          {showTooltip === 1 && (
                                            <div className="custom-tooltiptickets">
                                              <span>
                                                {state.internalTicketView
                                                  .InternalDepartments_Ticketsretrievedatas
                                                  ?.l1_users[0].phone_number
                                                  ? state.internalTicketView
                                                      .InternalDepartments_Ticketsretrievedatas
                                                      ?.l1_users[0].phone_number
                                                  : "897219837291873"}
                                              </span>
                                            </div>
                                          )}
                                          <div className="PhoneNumberShow">
                                            <img
                                              src={PhoneCalls}
                                              // data-tooltip-id="my-tooltip"
                                              // data-tooltip-content={
                                              //   state.internalTicketView.InternalDepartments_Ticketsretrievedatas?.l1_users[0]
                                              //     .phone_number
                                              //     ? state.internalTicketView.InternalDepartments_Ticketsretrievedatas?.l1_users[0]
                                              //       .phone_number
                                              //     : "897219837291873"
                                              // }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  }</div>
                          </div>
                        ) : null}

                        {state.internalTicketTimeline
                          .InternalDepartments_TicketsretrieveTimeline !=
                        undefined ? (
                          <div
                            className="issueAssigner"
                            style={{ marginTop: "7px" }}
                          >
                            <div className="Issues">
                              <p>Tracking</p>
                            </div>

                            <div className="timeline-containers timeline-containersprogress">
                              {state.internalTicketTimeline
                                .InternalDepartments_TicketsretrieveTimeline &&
                                Object.keys(
                                  state.internalTicketTimeline
                                    .InternalDepartments_TicketsretrieveTimeline
                                ).map((key, index) => {
                                  const item =
                                    state.internalTicketTimeline
                                      .InternalDepartments_TicketsretrieveTimeline[
                                      key
                                    ]; // Get the status object (e.g., open, inprogress, etc.)
                                  const getStatusText = (
                                    statusObj,
                                    statusKey
                                  ) => {
                                    if (statusObj) {
                                      return (
                                        <>
                                          <span>
                                            {statusObj.created_date
                                              ? `${new Date(
                                                  statusObj.created_date
                                                )
                                                  .toLocaleDateString("en-GB", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric",
                                                  })
                                                  .replace(",", "")}`
                                              : " "}
                                          </span>
                                        </>
                                      );
                                    }
                                  };

                                  return (
                                    <React.Fragment key={index}>
                                      <div
                                        className={`timeline-item ${
                                          item?.created_date
                                            ? "active"
                                            : "NotactiveInBars"
                                        }`}
                                      >
                                        <div
                                          className={`InnerTimelines ${
                                            item?.created_date ? "active" : ""
                                          }`}
                                        >
                                          <div className="dot"></div>
                                          <span>
                                            {item?.status != null &&
                                              capitalizeEachWord(item?.status)}
                                          </span>
                                        </div>
                                        <div
                                          className={`timeline-line ${
                                            item?.created_date ? "active" : ""
                                          }`}
                                        ></div>

                                        <p className="CreatedDateList">
                                          <span>
                                            {getStatusText(item, key)}
                                          </span>

                                          <span>
                                            {item.created_date
                                              ? extractTimeFromDate(
                                                  item.created_date
                                                )
                                              : ""}
                                          </span>
                                        </p>
                                      </div>
                                    </React.Fragment>
                                  );
                                })}
                            </div>
                          </div>
                        ) : null}

                        <div className="card RemarksCards shadow-sm p-3 mb-3">
                          <h6>
                            <span className="ticketheader RemarksHeaders">
                              Remarks{" "}
                            </span>
                          </h6>
                          {/* {state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark != null && state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark != undefined && state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark.length > 0 ? (
                            <>
                              <p className="Remarkspara">
                                {state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark.map((item, index) => {
                                  return (
                                    <>
                                      <div
                                        key={index}
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "5px",
                                        }}
                                      >
                                        <p className="Commentslist">
                                          {" "}
                                          <span>
                                            {capitalizeEachWord(item.name)}
                                          </span>{" "}
                                          {item.created_at != undefined ?
                                            <span>
                                              {item.created_at ? formatDatefeed(item.created_at) : " --"}
                                            </span>
                                            : null}
                                        </p>


                                        {
                                          state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark.documents != null &&
                                            state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark.documents != undefined &&
                                            state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark.documents.length > 0 &&
                                            state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark != undefined &&
                                            state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark != null &&
                                            state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark[index]?.documents
                                              .length > 0 ? (
                                            <p
                                              className="FileAttachments"
                                              style={{ width: "100%" }}
                                            >
                                              <span className="Attachmentslist">
                                                {" "}
                                                <img src={Attachment} />{" "}
                                                {
                                                  state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark[index]
                                                    ?.documents.length
                                                }{" "}
                                                File Attached
                                              </span>
                                              <span className="Downloadimgoptions">
                                                Download{" "}
                                                <img
                                                  src={downloadimg}
                                                  onClick={() =>
                                                    downloadAll(
                                                      state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark[index]
                                                        ?.documents
                                                    )
                                                  }
                                                />
                                              </span>
                                            </p>
                                          ) : null}


                                      </div>
                                    </>
                                  );
                                })}
                              </p>
                            </>
                          ) : (
                            <>--</>
                          )} */}

                          {state.internalcommandticketgetdata
                            .internaldepartmentticketgetdata != null &&
                          state.internalcommandticketgetdata
                            .internaldepartmentticketgetdata != undefined &&
                          state.internalcommandticketgetdata
                            .internaldepartmentticketgetdata.length > 0 ? (
                            <>
                              <p className="Remarkspara">
                                {state.internalcommandticketgetdata.internaldepartmentticketgetdata.map(
                                  (item, index) => {
                                    return (
                                      <>
                                        <div
                                          key={index}
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "5px",
                                          }}
                                        >
                                          <p className="Commentslist">
                                            {" "}
                                            <span>
                                              {capitalizeEachWord(item.name)}
                                            </span>{" "}
                                            {item.created_at != undefined ? (
                                              <span>
                                                {item.created_at
                                                  ? formatDatefeed(
                                                      item.created_at
                                                    )
                                                  : "No message yet"}
                                              </span>
                                            ) : null}
                                          </p>

                                          {/* {
                                          state.internalcommandticketgetdata.internaldepartmentticketgetdata.documents != null &&
                                            state.internalcommandticketgetdata.internaldepartmentticketgetdata.documents != undefined &&
                                            state.internalcommandticketgetdata.internaldepartmentticketgetdata.documents.length > 0 &&
                                            state.internalcommandticketgetdata.internaldepartmentticketgetdata != undefined &&
                                            state.internalcommandticketgetdata.internaldepartmentticketgetdata != null &&
                                            state.internalcommandticketgetdata.internaldepartmentticketgetdata[index]?.documents
                                              .length > 0 ? (
                                            <p
                                              className="FileAttachments"
                                              style={{ width: "100%" }}
                                            >
                                              <span className="Attachmentslist">
                                                {" "}
                                                <img src={Attachment} />{" "}
                                                {
                                                  state.internalcommandticketgetdata.internaldepartmentticketgetdata[index]
                                                    ?.documents.length
                                                }{" "}
                                                File Attached
                                              </span>
                                              <span className="Downloadimgoptions">
                                                Download{" "}
                                                <img
                                                  src={downloadimg}
                                                  onClick={() =>
                                                    downloadAll(
                                                      state.internalcommandticketgetdata.internaldepartmentticketgetdata[index]
                                                        ?.documents
                                                    )
                                                  }
                                                />
                                              </span>
                                            </p>
                                          ) : null} */}
                                          {item.documents != null &&
                                          item.documents != undefined &&
                                          item.documents.length > 0 &&
                                          item != undefined &&
                                          item != null &&
                                          item?.documents.length > 0 ? (
                                            // state.internalcommandticketgetdata.internaldepartmentticketgetdata[index]?.documents
                                            //     .length > 0 ? (
                                            <p
                                              className="FileAttachments"
                                              style={{
                                                width: "100%",
                                                flexDirection: "row",
                                                alignItems: "center",
                                              }}
                                            >
                                              <span className="Attachmentslist">
                                                {" "}
                                                <img src={Attachment} />
                                                {item?.documents.length}
                                                {`  File Attached`}
                                              </span>
                                              <span
                                                className="Downloadimgoptions"
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  gap: "7px",
                                                }}
                                              >
                                                Download
                                                <img
                                                  src={downloadimg}
                                                  onClick={() =>
                                                    downloadAll(item?.documents)
                                                  }
                                                />
                                              </span>
                                            </p>
                                          ) : null}
                                        </div>
                                      </>
                                    );
                                  }
                                )}
                              </p>
                            </>
                          ) : (
                            <>No message yet</>
                          )}
                        </div>

                        {/* {state.internalTicketView.InternalDepartments_Ticketsretrievedatas?.status != null ? ( */}
                        {/* {
                          state.internalTicketView.InternalDepartments_Ticketsretrievedatas.client_ticket_id ==  null

                          &&
                          state.internalTicketView.InternalDepartments_Ticketsretrievedatas.over_due == false

                          && (
                            <>
                              {state.internalTicketView.InternalDepartments_Ticketsretrievedatas?.status == 2 ||
                                state.internalTicketView.InternalDepartments_Ticketsretrievedatas?.status == 3 ? (
                                <div className="card Satisfactioncard shadow-sm p-3 mb-3">
                                  <p className="mb-1 cardpara heaerspara">
                                    <span className="ticketheader ticketheadercards">
                                      Satisfaction
                                    </span>
                                  </p>

                                  <p className="mb-1 cardpara heaerspara">
                                    Your feedback brings us great satisfaction and
                                    inspires us to improve further!
                                  </p>

                                  <div className="feedback">
                                    {feedbackOptions.map((option) => (
                                      <div
                                        key={option.id}
                                        className={`feedback-option ${activeFeedback === option.id
                                          ? "active"
                                          :
                                          feedbackDisabled == true
                                            ? "disabledthefiled "
                                            : ""
                                          }`}
                                        onClick={() => {
                                          if (
                                            feedbackDisabled == true
                                          ) {
                                          } else {
                                            handleFeedbackClick(option.id);
                                          }
                                          // handleFeedbackClick(option.id);

                                        }}
                                      >
                                        <img src={option.imgSrc} alt={option.label} />
                                        <span>{option.label}</span>
                                      </div>
                                    ))}
                                  </div>

                                  <div className="FeedbackField FeedbackFieldstatifications">
                                    <label className="form-label labelstart">
                                      Please submit your feedback.
                                    </label>
                                    <textarea
                                      value={CommentPart.feedbacks}
                                      className={`${state.internalTicketFeedBack.InternalDepartments_TicketsFeedback?.id ? "disabledthefiled" : ""
                                        }`}
                                      disabled={feedbackDisabled == true ? true : false}
                                      // disabled={state.internalTicketFeedBack.InternalDepartments_TicketsFeedback?.id ? true : false}
                                      onChange={(e) => {
                                        const inputValue = e.target.value;

                                        setcommentpart({
                                          ...CommentPart,
                                          feedbacks:
                                            inputValue.charAt(0).toUpperCase() +
                                            inputValue.slice(1),
                                        });
                                      }}
                                    ></textarea>
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}

                            </>
                          )} */}
                      </div>

                      {state.internalTicketView
                        .InternalDepartments_Ticketsretrievedatas?.status !=
                      3 ? (
                        <>
                          {state.internalTicketView
                            .InternalDepartments_Ticketsretrievedatas?.status ==
                            2 ||
                          state.internalTicketView
                            .InternalDepartments_Ticketsretrievedatas?.status ==
                            3 ? (
                            <div className="   Createticketsviewed ClosingtheTickets">
                              <button
                                className="OpenButtons"
                                onClick={() => {
                                  setcommentpart({
                                    ...CommentPart,
                                    status: 4,
                                  });
                                  setcommetpoup(true);
                                  HandleFeedbackpopup("Reopen");
                                  // HandletheComments();
                                }}
                              >
                                Reopen
                              </button>
                              <button
                                className="OpenButtons"
                                onClick={() => {
                                  if (
                                    state.internalTicketView
                                      .InternalDepartments_Ticketsretrievedatas
                                      .over_due == true
                                  ) {
                                    settheClientCloseTicket(true);
                                  } else {
                                    setTicketClosised(true);
                                    // setcommentpart({
                                    //   ...CommentPart,
                                    //   status: 0,
                                    // })

                                    // if (CommentPart.feedbacks == "") {
                                    //   toast.info(
                                    //     "Please Enter the Valid Details"
                                    //   );
                                    // } else {
                                    //   settheclosingTicketing(true);
                                    // }
                                  }
                                }}
                              >
                                Close
                              </button>
                            </div>
                          ) : null}
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {Closingtheticket && (
        <div className="CommentPopup CommentPopupthanks">
          <div className="innercommentpopup">
            <div
              className={`FormPartsthanks ${
                activeFeedback == "good" || activeFeedback == "excellent"
                  ? "FormPartsthankspopthanksdesigs"
                  : "FormPartsthankspopupTicketingview"
              } `}
            >
              <div className="innerformscomentpart">
                <div className="closecontent CloseIcons">
                  <img
                    src={closepopup}
                    alt=""
                    onClick={(e) => {
                      {
                        settheclosingTicketing(false);
                      }
                    }}
                  />
                </div>

                <div className="FeedbackField">
                  <label
                    className="form-label"
                    style={{ fontSize: "22px", fontWeight: "500" }}
                  >
                    Are you sure you want to close the ticket?
                  </label>
                </div>
                <div className="feedbacksubmition" style={{ bottom: "12px" }}>
                  <button
                    style={{ marginRight: "10px" }}
                    onClick={(e) => {
                      settheclosingTicketing(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={(e) => {
                      setcommentpart({
                        ...CommentPart,
                        status: 0,
                      });
                      HandleTheTicketChanges(3);
                      // setReviewPopup(false);
                    }}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {state.NeededdatasListed.Ticketpopup_thanks && (
        <>
          <div className="CommentPopup CommentPopupthanks">
            <div className="innercommentpopup">
              <div
                className={`FormPartsthanks ${
                  activeFeedback == "good" || activeFeedback == "excellent"
                    ? "FormPartsthankspopthanksdesigs"
                    : "FormPartsthankspopupTicketingview"
                } `}
              >
                <div className="innerformscomentpart">
                  <div className="Notifyimgsthumbs">
                    <img src={thumbsup} />
                  </div>
                  <div className="closecontent CloseIcons">
                    <img
                      src={closepopup}
                      alt=""
                      onClick={(e) => {
                        {
                          // settheThankpopupticketview(false);
                          // dispatch(settehTicketthankspopup(false))

                          // settheThanksContent(false);
                          setTimeout(() => {
                            dispatch(settehTicketthankspopup(false));
                            settheThanksContent(false);
                          }, 300);
                          // Navigate("/internalTicket");
                          if (state.NeededdatasListed.RoutesDefinedof == 0) {
                            Navigate("/internaldashboard");
                          } else {
                            Navigate("/internalTicket");
                          }
                        }
                      }}
                    />
                  </div>

                  <h5 className="pt-4" style={{ textAlign: "center" }}>
                    {activeFeedback == "excellent" || activeFeedback == "good"
                      ? "Thank you!"
                      : "Feedback Received"}
                  </h5>

                  <div className="FeedbackField">
                    {activeFeedback == "excellent" ||
                    activeFeedback == "good" ? (
                      <label className="form-label">
                        We appreciate you taking the time to share your
                        feedback.
                      </label>
                    ) : (
                      <label className="form-label">
                        Thank you for bringing this to our attention
                        <br />
                      </label>
                    )}
                  </div>
                  <div
                    className="feedbacksubmition"
                    style={{ marginTop: "-21px" }}
                  >
                    <button
                      onClick={(e) => {
                        // settheThankpopupticketview(false);

                        setTimeout(() => {
                          dispatch(settehTicketthankspopup(false));
                          settheThanksContent(false);
                        }, 300);

                        // Navigate("/internalTicket");
                        if (state.NeededdatasListed.RoutesDefinedof == 0) {
                          Navigate("/internaldashboard");
                        } else {
                          Navigate("/internalTicket");
                        }
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {Commentpopup && (
        <>
          <div className="CommentPopup">
            <div className="innercommentpopup">
              <div className="FormParts">
                <div className="innerformscomentpart">
                  <div className="Notifyimgs">
                    <img src={notifyimg} />
                  </div>
                  <div className="closecontent CloseIcons">
                    <img
                      src={closepopup}
                      alt=""
                      onClick={() => {
                        setUploadedFiles([]);
                        setcroppedFilestatet([]);
                        setPresentUrls([]);
                        seturlandfile([]);
                        setremarksreopendata({
                          name: "",
                          documents: "",
                        });
                        setcommetpoup(false);
                      }}
                    />
                  </div>

                  <h5 className="pt-3">{`${
                    state.internalTicketView
                      .InternalDepartments_Ticketsretrievedatas.status == 4
                      ? `Confirm Reopening `
                      : `Confirm Ticket closure`
                  }`}</h5>

                  <div className="RemarksForms">
                    <div className="FeedbackField  remarksInnerbox">
                      <label className="form-label labelstart">{`${
                        state.internalTicketView
                          .InternalDepartments_Ticketsretrievedatas.status == 3
                          ? `Enter your reason for closing.`
                          : `Please submit your feedback.`
                      }`}</label>

                      <textarea
                        value={remarksreopendatas.name}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          setremarksreopendata({
                            ...remarksreopendatas,
                            name:
                              inputValue.charAt(0).toUpperCase() +
                              inputValue.slice(1),
                          });
                        }}
                      ></textarea>
                    </div>

                    <div className="FeedbackField DocumentUploads remarksInnerbox">
                      <label className="form-label LabelRemove">
                        Documents Upload
                      </label>
                      <div
                        className="form-control InnerControls"
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        style={{
                          borderRadius: "10px",
                          padding: "23px",

                          textAlign: "center",
                          backgroundColor: isDragging
                            ? "hsla(203, 49%, 81%, 0.25)"
                            : "transparent", // Change background color
                          transition: "background-color 0.3s ease", // Smooth transition
                        }}
                      >
                        <div className="d-flex flex-wrap align-items-center justify-content-center gap-3">
                          {PresentUrls.map((file, index) => {
                            let displayImg;
                            // if (
                            //   file.type === "image/png" ||
                            //   file.type === "image/jpeg"
                            // ) {
                            //   displayImg = Attachment; // Replace with your gallery image variable
                            // } else if (file.type === "application/pdf") {
                            //   displayImg = Attachment; // Replace with your PDF icon variable
                            // } else if (
                            //   file.type === "application/vnd.ms-excel" ||
                            //   file.type ===
                            //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            // ) {
                            //   displayImg = Attachment; // Replace with your Excel icon variable
                            // } else {
                            //   displayImg = Attachment; // Replace with a default image/icon if none match
                            // }

                            if (
                              file.type === "image/png" ||
                              file.type === "image/jpeg"
                            ) {
                              displayImg = galleyimg; // Replace with your gallery image variable
                            } else if (file.type === "application/pdf") {
                              displayImg = PDFIMAGE; // Replace with your PDF icon variable
                            } else if (
                              file.type === "application/vnd.ms-excel" ||
                              file.type ===
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            ) {
                              displayImg = excelimg; // Replace with your Excel icon variable
                            } else {
                              displayImg = gallimages; // Replace with a default image/icon if none match
                            }

                            return (
                              <>
                                <div
                                  key={index}
                                  style={{
                                    position: "relative",
                                    width: "38px",
                                    height: "48px",
                                    borderRadius: "8px",
                                  }}
                                >
                                  <img
                                    src={Attachment}
                                    alt={`Uploaded File ${index + 1}`}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      borderRadius: "8px",
                                      border: "1px solid #ddd",
                                    }}
                                  />
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {console.log(file, "sdklaklsdlkklaslkd")}
                                    {file?.putfiles?.name?.length > 3
                                      ? `${file?.putfiles.name.slice(0, 3)}...`
                                      : file?.putfiles?.name}
                                  </span>
                                  <button
                                    type="button"
                                    className=" btn-danger btn-sm DeleteImages"
                                    onClick={() => removeFile(index)}
                                  >
                                    &times;
                                  </button>
                                </div>
                              </>
                            );
                          })}

                          {PresentUrls.length == 0 && (
                            <div className="InnerImages d-flex flex-wrap align-items-center  justify-content-center">
                              <img src={backimg} />
                            </div>
                          )}
                        </div>

                        <p className="mt-3 ">
                          <span
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              gap: "5px",
                              marginBottom: "20px",
                              alignItems: "center",
                            }}
                          >
                            <span style={{ textWrap: "nowrap" }}>
                              Drag your files here to upload or{" "}
                            </span>
                            <label
                              className="Droplabel"
                              htmlFor="fileUploadInput"
                              style={{
                                cursor: "pointer",
                                color: "#234492",
                                width: "10%",
                                textWrap: "nowrap",
                              }}
                            >
                              Browse file
                            </label>
                            <input
                              id="fileUploadInput"
                              type="file"
                              style={{ display: "none" }} // Hidden input
                              onChange={handleFileChange} // Handles file selection
                              multiple // Allows multiple file selection
                            />
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="feedbacksubmition">
                    <button
                      onClick={() => {
                        HandlethRemarksfromclient();
                      }}
                    >
                      {CommentPart.status == 2 ? "Close Ticket" : "Reopen"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {ClientTicketClose && (
        <>
          <div className="CommentPopup">
            <div className="innercommentpopup">
              <div className="FormParts ticketCloseforLoneusers">
                <div className="innerformscomentpart">
                  <div className="Notifyimgs">
                    <img src={notifyimg} />
                  </div>
                  <div className="closecontent CloseIcons">
                    <img
                      src={closepopup}
                      alt=""
                      onClick={() => {
                        setUploadedFiles([]);
                        setcroppedFilestatet([]);
                        setPresentUrls([]);
                        seturlandfile([]);
                        setexcalationdata({
                          l1_remarks: "",
                          l1_reason: "",
                        });
                        settheClientCloseTicket(false);
                      }}
                    />
                  </div>

                  <h5 className="pt-3">{`Confirm Ticket closure`}</h5>

                  <div className="RemarksForms">
                    <div className="FeedbackField  remarksInnerbox">
                      <label className="form-label labelstart">{`Enter your remarks for closing`}</label>

                      <input
                        value={excalationdata.l1_remarks}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          setexcalationdata({
                            ...excalationdata,
                            l1_remarks:
                              inputValue.charAt(0).toUpperCase() +
                              inputValue.slice(1),
                          });
                        }}
                        className="form-control"
                      ></input>
                    </div>

                    <div className="FeedbackField  remarksInnerbox">
                      <label className="form-label labelstart">{`Enter your reason for closing`}</label>

                      <textarea
                        value={excalationdata.l1_reason}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          setexcalationdata({
                            ...excalationdata,
                            l1_reason:
                              inputValue.charAt(0).toUpperCase() +
                              inputValue.slice(1),
                          });
                        }}
                        className="Textareafos"
                      ></textarea>
                    </div>

                    <div className="FeedbackField DocumentUploads remarksInnerbox">
                      <label className="form-label LabelRemove">
                        Documents Upload
                      </label>
                      <div
                        className="form-control InnerControls"
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        style={{
                          borderRadius: "10px",
                          padding: "23px",

                          textAlign: "center",
                          backgroundColor: isDragging
                            ? "hsla(203, 49%, 81%, 0.25)"
                            : "transparent", // Change background color
                          transition: "background-color 0.3s ease", // Smooth transition
                        }}
                      >
                        <div
                          className={`d-flex flex-wrap align-items-center ${
                            PresentUrls.length > 0
                              ? "Hanldthelefts"
                              : "Hanldthecentered"
                          } gap-3`}
                        >
                          {PresentUrls.map((file, index) => {
                            let displayImg;

                            if (
                              file.type === "image/png" ||
                              file.type === "image/jpeg"
                            ) {
                              displayImg = galleyimg; // Replace with your gallery image variable
                            } else if (file.type === "application/pdf") {
                              displayImg = PDFIMAGE; // Replace with your PDF icon variable
                            } else if (
                              file.type === "application/vnd.ms-excel" ||
                              file.type ===
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            ) {
                              displayImg = excelimg; // Replace with your Excel icon variable
                            } else {
                              displayImg = gallimages; // Replace with a default image/icon if none match
                            }

                            return (
                              <>
                                <div
                                  key={index}
                                  style={{
                                    position: "relative",
                                    width: "38px",
                                    height: "48px",
                                    borderRadius: "8px",
                                  }}
                                >
                                  <img
                                    src={Attachment}
                                    alt={`Uploaded File ${index + 1}`}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      borderRadius: "8px",
                                      border: "1px solid #ddd",
                                    }}
                                  />
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {console.log(file, "sdklaklsdlkklaslkd")}
                                    {file?.putfiles?.name?.length > 3
                                      ? `${file?.putfiles.name.slice(0, 3)}...`
                                      : file?.putfiles?.name}
                                  </span>
                                  <button
                                    type="button"
                                    className=" btn-danger btn-sm DeleteImages"
                                    onClick={() => removeFile(index)}
                                  >
                                    &times;
                                  </button>
                                </div>
                              </>
                            );
                          })}

                          {PresentUrls.length == 0 && (
                            <div className="InnerImages d-flex flex-wrap align-items-center  justify-content-center">
                              <img src={backimg} />
                            </div>
                          )}
                        </div>

                        <p className="mt-3 ">
                          <span
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              gap: "5px",
                              marginBottom: "20px",
                              alignItems: "center",
                            }}
                          >
                            <span style={{ textWrap: "nowrap" }}>
                              Drag your files here to upload or{" "}
                            </span>
                            <label
                              className="Droplabel"
                              htmlFor="fileUploadInput"
                              style={{
                                cursor: "pointer",
                                color: "#234492",
                                width: "10%",
                                textWrap: "nowrap",
                              }}
                            >
                              Browse file
                            </label>
                            <input
                              id="fileUploadInput"
                              type="file"
                              style={{ display: "none" }} // Hidden input
                              onChange={handleFileChange} // Handles file selection
                              multiple // Allows multiple file selection
                            />
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="feedbacksubmition">
                    <button
                      onClick={() => {
                        HandletheClientTicketClose();
                      }}
                    >
                      {"Close Ticket"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {ticketCloseIsed && (
        <div className="CommentPopup CommentPopupthanks">
          <div className="innercommentpopup">
            <div
              className={`FormPartsthanks ${
                activeFeedback == "good" || activeFeedback == "excellent"
                  ? "FormPartsthankspopthanksdesigs"
                  : "FormPartsthankspopupTicketingview"
              } `}
            >
              <div className="innerformscomentpart">
                <div className="closecontent CloseIcons">
                  <img
                    src={closepopup}
                    alt=""
                    onClick={(e) => {
                      {
                        setTicketClosised(false);
                      }
                    }}
                  />
                </div>

                <div className="FeedbackField">
                  <label
                    className="form-label"
                    style={{ fontSize: "22px", fontWeight: "500" }}
                  >
                    Are you sure you want to close the ticket?
                  </label>
                </div>
                <div className="feedbacksubmition" style={{ bottom: "12px" }}>
                  <button
                    style={{ marginRight: "10px" }}
                    onClick={(e) => {
                      setTicketClosised(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={(e) => {
                      setcommentpart({
                        ...CommentPart,
                        status: 0,
                      });
                      HandleTheTicketofCloseChanges(3);

                      // setReviewPopup(false);
                    }}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* <Tooltip id="my-tooltip" place="top" effect="solid" /> */}
    </>
  );
};

export default InternalTicketingView;
